import localStore from '../utils/localStore'
import JsonUtils from '../utils/json'

let state = {
  params:'',//20200916 /index路由 向 /indexTwo路由传递的参数
  uid: '',
  name: '',
  utoken: '',
  selected: "list",//默认选择学习足迹
  tab: "1",
  role:"",
  loginTime:"",//登录时间
  isLogin: false,//是否已经登录
  userId: "",//用户uuid
  userNumber:"",//学号
  userName: "",//用户名
  multipleSelection: [],
  back:undefined,

  // anonymousUserId:""
};

const mutations = {
  updateParams(state, params) {
    state.params = params;
  },

  updateMultipleSelection(state, multipleSelection) {
    state.multipleSelection = multipleSelection;
  },
  updateSelected(state, selected) {
    state.selected = selected;
  },
  updateTab(state, tab) {
    state.tab = tab;
  },
  updateBack(state, back) {
    state.back = back;
  },
  updateLoginTime(state, loginTime) {
    state.loginTime = loginTime;
  },
  updateRole(state, role) {
    state.role = role;
  },
  updateIsLogin(state, isLogin) {
    state.isLogin = isLogin;
  },
  updateUserId(state, userId) {
    state.userId = userId;
  },
  updateUserNumber(state, userNumber) {
    state.userNumber = userNumber;
  },
  updateUserName(state, userName) {
    state.userName = userName;
  },
  save(state, user) {
    state.user = user
    if (user !== null) {
      state.uid = user.id
      state.name = user.username
      state.utoken = user.api_token
      localStore.setItem('mobUser', JsonUtils.jsonToString(state.user))
    }
  },
  flash(state) {
    let tmp = localStore.getItem('mobUser', null)
    let user = tmp === null ? null : JsonUtils.stringToJson(tmp)
    state.user = user
    if (user !== null) {
      state.uid = user.id
      state.name = user.username
      state.utoken = user.api_token
    }
  },
  clear(state) {
    state.uid = ''
    state.name = ''
    state.utoken = ''
    localStore.removeItem('mobUser')
  }
};

// 事件触发后的逻辑操作
// 参数为事件函数
const actions = {
  updateParams({ commit }, params) {
    commit("updateParams", params);
  },

  updateMultipleSelection({ commit }, multipleSelection) {
    commit("updateMultipleSelection", multipleSelection);
  },
  updateSelected({ commit }, selected) {
    commit("updateSelected", selected);
  },
  updateTab({ commit }, tab) {
    commit("updateTab", tab);
  },
  updateBack({ commit }, back) {
    commit("updateBack", back);
  },
  updateLoginTime({ commit }, loginTime) {
    commit("updateLoginTime", loginTime);
  },
  updateRole({ commit }, role) {
    commit("updateRole", role);
  },
  updateIsLogin({ commit }, isLogin) {
    commit("updateIsLogin", isLogin);
  },
  updateUserId({ commit }, userId) {
    commit("updateUserId", userId);
  },
  updateUserNumber({ commit }, userNumber) {
    commit("updateUserNumber", userNumber);
  },
  updateUserName({ commit }, userName) {
    commit("updateUserName", userName);
  },
  updateNav({ commit }, msg) {
    commit('mobUser', { uid: '', name: '' })    // 提交到mutations中处理
  }
};

// 返回改变后的数值
const getters = {
  params: state => state.params,
  
  uid: state => state.uid,
  name: state => state.name,
  utoken: state => state.utoken,
  selected: state => state.selected,
  tab: state => state.tab,
  back: state => state.back,
  isLogin: state => state.isLogin,
  userId: state => state.userId,
  userName: state => state.userName,
  multipleSelection: state => state.multipleSelection
};

export default {
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/mineStore.js